import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import FactForm from "./FactForm";
import Fact, { IFact } from "../../../model/evaluation/Fact";

export interface State {}

export interface UpdateFactFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: IFact;
  codebooks: { factDataTypes: Array<{ id: string; name: string }> };
}

class UpdateFactForm extends React.Component<UpdateFactFormProps, State> {
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let updatedRecord;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          updatedRecord = Fact(values);
          updatedRecord.id = rowData.id;
        }
      });
      return updatedRecord;
    });
  }

  render() {
    const { translate, rowData, codebooks } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <FactForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        rowData={rowData}
        codebooks={codebooks}
      />
    );
  }
}

export default UpdateFactForm;
